var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"design_box_out"},[_c('div',{staticClass:"company-desc design_box"},[_vm._v("\n      "+_vm._s(_vm.property.body)+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }